import React, { useContext, useEffect } from 'react'
import { SearchContext } from '../search/SearchContext'
import moment from 'moment'

const HotelRoomsCancellationPolicy = () => {
  const {
    state: { room },
  } = useContext(SearchContext)

  useEffect(() => {
    _renderInfo()
  },[room])

  const _convertDate = (date) => {
    return moment.parseZone(date).format('HH:mm on MM/DD/YYYY')
  }

  const _renderCancellationPoliciesForRoom = (policies, rate) => {
    return policies.map((policy, i) => {
      if (rate.rateClass === 'NRF') {
        return (
          <React.Fragment key={i}>
          <dt className="strong">*NON-REFUNDABLE Exclusive Rate</dt>
          <dd className="strong">This room type is non-refundable</dd>
          <dt className="nrf-policy"><b>After</b> {_convertDate(policy.from)}</dt>
          <dd className="nrf-policy">You cannot cancel or modify this reservation</dd>
          </React.Fragment>
        )
      } else {
        return (
          <React.Fragment key={i}>
          <dt className="full-width thin">
          A fee of ${policy.amount} will apply to cancel this room after {_convertDate(policy.from)}.
            </dt>
          </React.Fragment>
        )
      }
    })
  }

  const _renderInfo = () => {
    if (!room) return
    let charges = undefined
    if ("rates" in room) {
      charges = room.rates.map((rate) => {
        if ('cancellationPolicies' in rate) {
          if (Array.isArray(rate.cancellationPolicies)) {
            return _renderCancellationPoliciesForRoom(rate.cancellationPolicies, rate)
          } else {
            return Object.keys(rate.cancellationPolicies).map((hotelName) => {
              return (
                <>
                  <h4>{hotelName}</h4>
                  {_renderCancellationPoliciesForRoom(rate.cancellationPolicies[hotelName], rate)}
                </>
              )
            })
          }
        }
      })
    }

    if (charges) return <dl className="space-between">{charges}</dl>
  }

  const _displayHtml = () => (
    <React.Fragment>
      <h3>Cancellation Policy <small>for selected room</small></h3>
      { _renderInfo() }
    </React.Fragment>
  )

  return (
    <div className="cancellation">
      { room && _displayHtml() }
    </div>
  )
}

export default HotelRoomsCancellationPolicy
